export const getPaymentInfoFrag = `
    validFrom
`;

export const puroSettingFrag = `
    coefficients {
        name
        description
    }
`;
